import { ActionReducerMap } from '@ngrx/store';
import * as CheckoutBillingAddressReducer from './checkout-billing-address.reducer';
import * as CheckoutIncotermReducer from './incoterm.reducer';
import * as CheckoutCartsReducer from './checkout-carts.reducer';
import * as CheckoutCountriesReducer from './countries.reducer';
import * as CheckoutSubmitOrderReducer from './checkout-submit-order.reducer';

export const customReducers: ActionReducerMap<any> = {
    billingAddress: CheckoutBillingAddressReducer.reducer,
    incoterm: CheckoutIncotermReducer.reducer,
    carts: CheckoutCartsReducer.reducer,
    countries: CheckoutCountriesReducer.reducer,
    submitOrder: CheckoutSubmitOrderReducer.reducer,
}
